module.exports = __webpack_public_path__ + "ui-static/img/not-found-alien_light.0ab380e8.svg";